import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "3 WhatsApp Funnels That Drove 77% More Leads (Steal These!)",
    listHeading:
        "Struggling with low email open rates or poor lead conversions? You’re not alone — and more importantly, there’s a smarter way to fix it. What you’ll learn in this webinar:",
    listText: [
        { label: "Why traditional funnels are broken — and how WhatsApp is changing the game" },
        { label: "3 real funnels from EdTech, D2C, and Travel businesses" },
        { label: "The exact flows, tools, and messages used to convert leads faster" },
        { label: "How to replicate these funnels in minutes using Gallabox" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-2.png",
    speakerList: [
        {
            image: "/vidhya.png",
            name: "Vidhya S",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/Ef1x3BM6MmU",
    inThisWebinar: "What you'll learn in this webinar:",
    webinarSlug: "whatsapp-funnels",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="3 WhatsApp funnels that got 77% more leads for our customers"
            description="Steal proven WhatsApp funnel strategies that helped our clients grow leads by 77% — watch the webinar now"
            canonical="https://gallabox.com/webinars/whatsapp-funnels"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-2.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
